export default function Process() {
  return (
    <div>
      {/* Desktop */}
      <div className="hidden lg:block bg-gray-torq-light process_bg h-full">
        <div className="py-24 flex justify-center items-center w-full h-full">
          <div>
            <div className="text-center">
              <p className="mt-2 text-2xl leading-8 font-black font-roboto tracking-tight text-light-green sm:text-4xl">
                What is our process?
              </p>
            </div>
            <div className="pt-5 lg:pt-10">
              {/* Ideation */}
              <div className="grid lg:grid-cols-3 gap-10 pt-10">
                <div></div>

                <div className="bg-white py-5 rounded-lg h-auto cursor-pointer hover:shadow-xl text-dark hover:text-green-3">
                  <div>
                    <div>
                      <IdeaIcon />
                    </div>

                    <div className="text-gray-5 font-bold mt-2 mb-1 text-lg text-center">
                      Ideation
                    </div>
                    <div>
                      <p className="text-center text-gray-5 leading-5">
                        Identify innovative <br /> investment opportunities
                      </p>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>

              {/* Portfolio and Risk Management & Sizing the Opportunity */}
              <div className="grid lg:grid-cols-3 gap-10 pt-10">
                <div className="bg-white py-5 rounded-lg h-auto cursor-pointer hover:shadow-xl text-dark hover:text-green-3">
                  <div>
                    <div>
                      <GearIcon />
                    </div>
                    <div className="text-gray-5 font-bold mt-2 mb-1 text-lg text-center">
                      Portfolio and Risk Management
                    </div>
                    <div>
                      <p className="text-center text-gray-5">
                        Monitor conviction and market volatility
                      </p>
                    </div>
                  </div>
                </div>

                <div></div>

                <div className="bg-white py-5 rounded-lg h-auto cursor-pointer hover:shadow-xl text-dark hover:text-green-3">
                  <div className="w-4/5 mx-auto">
                    <div>
                      <MagnifyingIcon />
                    </div>
                    <div className="text-gray-5 font-bold mt-2 mb-1 text-lg text-center">
                      Sizing the Opportunity
                    </div>
                    <div>
                      <p className="text-center text-gray-5 leading-5">
                        Define the potential high performing investments
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Stock Selection and Valuation */}
              <div className="grid lg:grid-cols-3 gap-10 pt-10">
                <div></div>

                <div className="bg-white py-5 rounded-lg h-auto cursor-pointer hover:shadow-xl text-dark hover:text-green-3">
                  <div className="w-4/5 mx-auto">
                    <div>
                      <StockIcon />
                    </div>
                    <div className="text-gray-5 font-bold mt-2 mb-1 text-lg text-center">
                      Stock Selection and Valuation
                    </div>
                    <div>
                      <p className="text-center text-gray-5">
                        Select investment portfolios
                      </p>
                    </div>
                  </div>
                </div>

                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div className="block lg:hidden bg-gray-torq-light h-full">
        <div className="py-16 px-4 lg:px-0">
          <div>
            <div className="text-center">
              <p className="mt-2 text-2xl leading-8 font-black font-roboto tracking-tight text-light-green sm:text-4xl">
                What is our process?
              </p>
            </div>
            <div className="pt-10">
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white py-5 rounded-lg h-auto cursor-pointer hover:shadow-xl text-dark hover:text-green-3">
                  <div>
                    <div>
                      <IdeaIcon />
                    </div>

                    <div className="text-gray-5 font-bold mt-2 mb-1 text-center">
                      Ideation
                    </div>
                    <div>
                      <p className="text-center text-gray-5 text-sm leading-5">
                        Identify innovative <br /> investment opportunities
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white py-5 rounded-lg h-auto cursor-pointer hover:shadow-xl text-dark hover:text-green-3">
                  <div>
                    <div>
                      <GearIcon />
                    </div>
                    <div className="text-gray-5 font-bold mt-2 mb-1 text-center">
                      Portfolio and Risk Management
                    </div>
                    <div>
                      <p className="text-center text-gray-5 text-sm">
                        Monitor conviction and market volatility
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white py-5 rounded-lg h-auto cursor-pointer hover:shadow-xl text-dark hover:text-green-3">
                  <div className="w-4/5 mx-auto">
                    <div>
                      <MagnifyingIcon />
                    </div>
                    <div className="text-gray-5 font-bold mt-2 mb-1 text-center">
                      Sizing the Opportunity
                    </div>
                    <div>
                      <p className="text-center text-gray-5 text-sm leading-5">
                        Define the potential high performing investments
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white py-5 rounded-lg h-auto cursor-pointer hover:shadow-xl text-dark hover:text-green-3">
                  <div className="w-4/5 mx-auto">
                    <div>
                      <StockIcon />
                    </div>
                    <div className="text-gray-5 font-bold mt-2 mb-1 text-center">
                      Stock Selection and Valuation
                    </div>
                    <div>
                      <p className="text-center text-gray-5 text-sm">
                        Select investment portfolios
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const IdeaIcon = () => {
  return (
    <svg
      className="mx-auto"
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5421 50.6687H13.5339C13.1284 50.6687 12.7396 50.8298 12.4529 51.1164C12.1662 51.4031 12.0052 51.792 12.0052 52.1974C12.0052 52.6028 12.1662 52.9916 12.4529 53.2783C12.7396 53.565 13.1284 53.7261 13.5339 53.7261H27.5421C27.9475 53.7261 28.3364 53.565 28.623 53.2783C28.9097 52.9916 29.0708 52.6028 29.0708 52.1974C29.0708 51.792 28.9097 51.4031 28.623 51.1164C28.3364 50.8298 27.9475 50.6687 27.5421 50.6687V50.6687Z"
        className="fill-current"
      />
      <path
        d="M38.6274 22.2121L38.9862 22.1448L38.6259 22.2132L38.6274 22.2121ZM31.8619 16.3879C31.476 17.0496 31.3049 17.8174 31.3762 18.5845C31.4557 19.4396 31.8315 20.2401 32.4386 20.8476L32.4386 20.8476L33.6011 22.0107L33.6014 22.011C34.2089 22.6184 35.0097 22.9944 35.8651 23.0738C36.6324 23.145 37.4003 22.9737 38.062 22.5876C38.2112 23.1504 38.4923 23.6711 38.8836 24.1057C39.142 24.3928 39.4429 24.636 39.7742 24.8278C39.4446 27.4999 38.5598 30.0763 37.1736 32.3905C35.6671 34.9057 33.6079 37.0451 31.1521 38.6465C30.1648 39.2719 29.3489 40.1335 28.7781 41.1534C28.206 42.1755 27.8983 43.3242 27.8827 44.4954H27.8826L27.8826 44.5082L27.8818 46.2501V46.2506C27.8818 46.2741 27.8772 46.2974 27.8682 46.3192C27.8592 46.3409 27.846 46.3607 27.8293 46.3773C27.8127 46.394 27.7929 46.4072 27.7712 46.4162C27.7494 46.4252 27.7261 46.4298 27.7026 46.4298H22.81V32.7586H23.9901C23.9901 32.7586 23.9901 32.7586 23.9901 32.7586C25.5027 32.7586 26.9625 32.2027 28.0919 31.1965C29.2213 30.1902 29.9414 28.804 30.1152 27.3014C30.289 25.7988 29.9044 24.2848 29.0345 23.0473C28.3203 22.0312 27.3198 21.2597 26.1694 20.8251V19.5185C26.1745 19.2327 26.1234 18.9486 26.0188 18.6824C25.9124 18.4119 25.7531 18.1654 25.5501 17.9574C25.3471 17.7494 25.1045 17.5841 24.8367 17.4712C24.5688 17.3583 24.2811 17.3002 23.9905 17.3002C23.6998 17.3002 23.4121 17.3583 23.1443 17.4712C22.8764 17.5841 22.6339 17.7494 22.4309 17.9574C22.2278 18.1654 22.0685 18.4119 21.9622 18.6824C21.8576 18.9486 21.8064 19.2327 21.8115 19.5185V22.6071C21.8115 22.8933 21.8679 23.1767 21.9774 23.4411C22.087 23.7055 22.2475 23.9458 22.4498 24.1481C22.6522 24.3505 22.8925 24.511 23.1569 24.6205C23.4213 24.7301 23.7046 24.7864 23.9908 24.7864L23.9964 24.7864C24.2345 24.7851 24.4706 24.8308 24.6909 24.921C24.9113 25.0112 25.1117 25.1441 25.2805 25.312C25.4494 25.4799 25.5834 25.6796 25.6748 25.8994C25.7663 26.1193 25.8133 26.3551 25.8133 26.5932C25.8133 26.8314 25.7663 27.0671 25.6748 27.287C25.5834 27.5069 25.4494 27.7065 25.2805 27.8744C25.1117 28.0423 24.9113 28.1752 24.6909 28.2654C24.4706 28.3556 24.2345 28.4014 23.9964 28.4V28.4H23.9908L17.0853 28.4L17.0798 28.4C16.8416 28.4014 16.6056 28.3556 16.3852 28.2654C16.1648 28.1752 15.9645 28.0423 15.7956 27.8744C15.6268 27.7065 15.4928 27.5069 15.4013 27.287C15.3099 27.0671 15.2628 26.8314 15.2628 26.5932C15.2628 26.3551 15.3099 26.1193 15.4013 25.8994C15.4928 25.6796 15.6268 25.4799 15.7956 25.312C15.9645 25.1441 16.1648 25.0112 16.3852 24.921C16.6056 24.8308 16.8416 24.7851 17.0798 24.7864V24.7864H17.0853C17.3715 24.7864 17.6549 24.7301 17.9193 24.6205C18.1837 24.511 18.424 24.3505 18.6263 24.1481C18.8287 23.9458 18.9892 23.7055 19.0987 23.4411C19.2082 23.1767 19.2646 22.8933 19.2646 22.6071V19.5181C19.2694 19.2322 19.2179 18.9482 19.113 18.6821C19.0065 18.412 18.847 18.1659 18.6441 17.9583C18.4411 17.7506 18.1987 17.5856 17.9311 17.473C17.6634 17.3603 17.376 17.3023 17.0856 17.3023C16.7953 17.3023 16.5078 17.3603 16.2402 17.473C15.9726 17.5856 15.7302 17.7506 15.5272 17.9583C15.3243 18.1659 15.1648 18.412 15.0583 18.6821C14.9534 18.9482 14.9019 19.2322 14.9067 19.5181V20.8254C13.7563 21.26 12.7558 22.0314 12.0415 23.0476C11.1717 24.285 10.7871 25.7991 10.9609 27.3017C11.1347 28.8042 11.8548 30.1905 12.9842 31.1967C14.1135 32.2029 15.5734 32.7589 17.0859 32.7588C17.086 32.7588 17.086 32.7588 17.086 32.7588H18.4526V46.4301H13.276C13.2285 46.4301 13.1829 46.4112 13.1492 46.3776C13.1156 46.344 13.0967 46.2984 13.0967 46.2508V44.5818H13.0968L13.0967 44.5691C13.0814 43.3697 12.77 42.1927 12.1901 41.1427C11.6114 40.0947 10.783 39.2056 9.77862 38.5542C6.47379 36.3519 3.92493 33.1878 2.4768 29.4897C1.0279 25.7896 0.750872 21.7337 1.68321 17.871C2.61555 14.0083 4.71222 10.5253 7.68942 7.89361C10.6666 5.26188 14.3806 3.60847 18.3285 3.1572L18.3322 3.15677C22.9428 2.61242 27.5892 3.75609 31.4157 6.36711C31.4867 6.80783 31.6378 7.23272 31.8623 7.62038C31.1215 7.81553 30.4575 8.23756 29.9654 8.83051C29.417 9.49132 29.1167 10.3229 29.1162 11.1816V11.1822V12.8266V12.8272C29.1168 13.6858 29.4171 14.5172 29.9653 15.1778C30.4573 15.7707 31.1212 16.1927 31.8619 16.3879ZM17.0853 23.7864C16.7154 23.7844 16.3488 23.8554 16.0064 23.9956C15.6641 24.1357 15.3528 24.3421 15.0905 24.603C14.8282 24.8638 14.62 25.1739 14.478 25.5155C14.336 25.857 14.2628 26.2233 14.2628 26.5932C14.2628 26.9631 14.336 27.3294 14.478 27.671C14.62 28.0125 14.8282 28.3227 15.0905 28.5835C15.3528 28.8443 15.6641 29.0508 16.0064 29.1909C16.3488 29.331 16.7154 29.4021 17.0853 29.4H23.9908C24.3607 29.4021 24.7274 29.331 25.0698 29.1909C25.4121 29.0508 25.7234 28.8443 25.9857 28.5835C26.248 28.3227 26.4561 28.0125 26.5982 27.671C26.7402 27.3294 26.8133 26.9631 26.8133 26.5932C26.8133 26.2233 26.7402 25.857 26.5982 25.5155C26.4561 25.1739 26.248 24.8638 25.9857 24.603C25.7234 24.3421 25.4121 24.1357 25.0698 23.9956C24.7274 23.8554 24.3607 23.7844 23.9908 23.7864C23.836 23.7864 23.6826 23.7559 23.5395 23.6967C23.3965 23.6374 23.2665 23.5505 23.1569 23.441C23.0474 23.3315 22.9606 23.2015 22.9013 23.0584C22.8421 22.9154 22.8115 22.762 22.8115 22.6071L17.0853 23.7864Z"
        strokeWidth="2"
        className="stroke-current"
      />
      <path
        d="M52.2149 10.52L50.3098 10.1624C50.1314 10.1303 49.9645 10.0519 49.8259 9.93508C49.6873 9.81824 49.5818 9.66704 49.5199 9.49662C49.4329 9.25012 49.3331 9.00837 49.2207 8.77236C49.1443 8.60826 49.1122 8.42698 49.1276 8.2466C49.143 8.06622 49.2055 7.89304 49.3087 7.7443L50.4025 6.14573C50.4913 6.01599 50.5319 5.85932 50.5173 5.70282C50.5027 5.54632 50.4339 5.39983 50.3228 5.2887L49.1608 4.12628C49.0497 4.01511 48.9032 3.94629 48.7467 3.93174C48.5902 3.91719 48.4335 3.95783 48.3038 4.04662L46.7048 5.14011C46.5561 5.24338 46.3828 5.30587 46.2024 5.32137C46.022 5.33686 45.8406 5.30482 45.6764 5.22842C45.4405 5.11598 45.1987 5.01612 44.9522 4.92924C44.7818 4.86729 44.6307 4.76175 44.5138 4.62314C44.397 4.48453 44.3186 4.31769 44.2864 4.1393L43.9292 2.2342C43.9002 2.07972 43.8181 1.94023 43.6971 1.83986C43.5762 1.73949 43.4239 1.68456 43.2668 1.68457H41.6229C41.4657 1.68455 41.3134 1.73947 41.1925 1.83984C41.0715 1.94021 40.9894 2.07971 40.9605 2.2342L40.6031 4.1393C40.571 4.31772 40.4926 4.48459 40.3757 4.62321C40.2589 4.76184 40.1077 4.86736 39.9373 4.92924C39.6908 5.01619 39.449 5.11602 39.213 5.22834C39.0489 5.30476 38.8676 5.33682 38.6872 5.32134C38.5068 5.30586 38.3336 5.24338 38.1849 5.14011L36.5858 4.04627C36.4561 3.95748 36.2994 3.91684 36.1429 3.93139C35.9864 3.94594 35.8399 4.01476 35.7288 4.12593L34.5663 5.28809C34.4552 5.39924 34.3864 5.54574 34.3719 5.70225C34.3574 5.85876 34.398 6.01542 34.4868 6.14511L35.5807 7.74369C35.6839 7.89242 35.7464 8.06562 35.7618 8.24602C35.7773 8.42642 35.7452 8.60772 35.6687 8.77184C35.5566 9.0079 35.4568 9.24964 35.3697 9.49609C35.3079 9.66651 35.2023 9.8177 35.0637 9.93455C34.9251 10.0514 34.7582 10.1298 34.5798 10.1619L32.6747 10.5194C32.5202 10.5483 32.3807 10.6304 32.2804 10.7513C32.18 10.8723 32.1251 11.0245 32.1251 11.1817V12.8267C32.1251 12.9839 32.18 13.1361 32.2804 13.2571C32.3807 13.378 32.5202 13.4601 32.6747 13.4891L34.5798 13.8464C34.7582 13.8786 34.925 13.957 35.0637 14.0738C35.2023 14.1907 35.3078 14.3418 35.3697 14.5122C35.4567 14.7587 35.5565 15.0004 35.6687 15.2365C35.7452 15.4006 35.7773 15.5819 35.7618 15.7623C35.7464 15.9427 35.6839 16.1159 35.5807 16.2646L34.4868 17.8636C34.3981 17.9933 34.3574 18.1499 34.3719 18.3064C34.3864 18.4629 34.4552 18.6094 34.5663 18.7206L35.7288 19.8831C35.84 19.9942 35.9865 20.063 36.143 20.0775C36.2994 20.0921 36.4561 20.0515 36.5858 19.9627L38.1849 18.8689C38.3336 18.7656 38.5068 18.7031 38.6873 18.6876C38.8677 18.6721 39.049 18.7042 39.2132 18.7807C39.4492 18.8931 39.6909 18.9929 39.9375 19.0798C40.1078 19.1417 40.259 19.2473 40.3758 19.3859C40.4926 19.5245 40.571 19.6914 40.6031 19.8698L40.9605 21.7749C40.9894 21.9294 41.0715 22.0689 41.1925 22.1692C41.3134 22.2696 41.4657 22.3245 41.6229 22.3245H43.2668C43.4239 22.3245 43.5762 22.2696 43.6971 22.1692C43.8181 22.0688 43.9002 21.9294 43.9292 21.7749L44.2864 19.8698C44.3186 19.6914 44.397 19.5246 44.5138 19.3859C44.6307 19.2473 44.7818 19.1418 44.9522 19.0798C45.1987 18.9929 45.4404 18.8931 45.6764 18.7807C45.8406 18.7042 46.022 18.6721 46.2024 18.6876C46.3829 18.7031 46.5561 18.7656 46.7048 18.8689L48.3041 19.9623C48.4338 20.051 48.5905 20.0917 48.747 20.0771C48.9035 20.0625 49.0499 19.9937 49.1611 19.8825L50.3234 18.7201C50.4345 18.609 50.5033 18.4625 50.5179 18.306C50.5325 18.1496 50.4919 17.9929 50.4031 17.8632L49.3087 16.2642C49.2054 16.1155 49.1429 15.9423 49.1274 15.7619C49.1119 15.5815 49.144 15.4002 49.2204 15.236C49.3328 15.0001 49.4326 14.7583 49.5196 14.5119C49.5814 14.3414 49.6869 14.1902 49.8255 14.0733C49.9642 13.9565 50.1311 13.8781 50.3095 13.846L52.2146 13.4887C52.3691 13.4597 52.5086 13.3776 52.6089 13.2567C52.7093 13.1357 52.7642 12.9835 52.7642 12.8263V11.1823C52.7642 11.0252 52.7094 10.873 52.6091 10.752C52.5088 10.6311 52.3694 10.549 52.2149 10.52ZM42.4449 15.4762C41.7582 15.4762 41.0869 15.2726 40.5159 14.8911C39.945 14.5096 39.5 13.9674 39.2372 13.3329C38.9744 12.6985 38.9056 12.0004 39.0396 11.3269C39.1736 10.6534 39.5042 10.0348 39.9898 9.54923C40.4754 9.06367 41.094 8.733 41.7675 8.59903C42.441 8.46506 43.1391 8.53382 43.7735 8.7966C44.4079 9.05939 44.9502 9.5044 45.3317 10.0754C45.7132 10.6463 45.9168 11.3176 45.9168 12.0043C45.9168 12.9251 45.551 13.8082 44.8999 14.4593C44.2488 15.1104 43.3657 15.4762 42.4449 15.4762Z"
        className="stroke-current"
        strokeWidth="2"
      />
    </svg>
  );
};

const GearIcon = () => {
  return (
    <svg
      className="mx-auto"
      width="65"
      height="59"
      viewBox="0 0 65 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.7509 25.6314H38.154C36.9482 25.6314 35.9369 24.62 35.9369 23.3753C35.9369 22.753 36.1994 22.1987 36.6662 21.7805L37.6192 20.847C38.5625 19.9134 38.5625 18.3964 37.6192 17.4532L35.4507 15.3041C35.0228 14.8762 34.3907 14.6234 33.7489 14.6234C33.1071 14.6234 32.4847 14.8762 32.0471 15.3041L31.133 16.2182C30.6954 16.7044 30.0925 16.967 29.4605 16.967C28.2157 16.967 27.1558 15.9556 27.1558 14.7595V13.2912C27.1558 11.9784 26.1347 10.8503 24.8219 10.8503H21.8657C20.5238 10.8503 19.4541 11.9686 19.4541 13.2912V14.7693C19.4541 15.9654 18.4233 16.9767 17.1786 16.9767C16.5562 16.9767 15.9922 16.7141 15.5643 16.2571L14.6211 15.3235C14.1932 14.886 13.5611 14.6428 12.9193 14.6428C12.2775 14.6428 11.6551 14.8957 11.2175 15.3235L9.04901 17.4629C8.11547 18.3964 8.11547 19.9232 9.04901 20.847L9.9631 21.7611C10.4493 22.1987 10.7216 22.753 10.7216 23.385C10.7216 24.6298 9.71027 25.6411 8.50445 25.6411H7.02635C5.69411 25.6314 4.57581 26.7205 4.57581 28.043V29.5211V30.9992C4.57581 32.312 5.69411 33.4109 7.02635 33.4109H8.50445C9.71027 33.4109 10.7216 34.4222 10.7216 35.6669C10.7216 36.2893 10.4493 36.863 9.9631 37.3006L9.04901 38.1952C8.11547 39.1288 8.11547 40.6458 9.04901 41.5793L11.2175 43.7381C11.6454 44.1757 12.2775 44.4188 12.9193 44.4188C13.5611 44.4188 14.1835 44.166 14.6211 43.7381L15.5643 42.8046C15.9728 42.3476 16.5465 42.085 17.1689 42.085C18.4136 42.085 19.4444 43.0963 19.4444 44.2924V45.7705C19.4444 47.0833 20.514 48.2113 21.8463 48.2113H24.8025C26.125 48.2113 27.2238 47.093 27.2238 45.7705V44.2924C27.2238 43.2728 27.9659 42.3874 28.956 42.1484L29.9025 40.5522C29.7662 40.5369 29.6284 40.5291 29.4896 40.5291C28.4783 40.5291 27.5448 40.9181 26.8154 41.6182C26.0764 42.3378 25.6874 43.2811 25.6874 44.2924V45.7705C25.6874 46.247 25.2693 46.6554 24.8219 46.6554H21.8657C21.4184 46.6554 21.0197 46.247 21.0197 45.7705V44.2924C21.0197 43.2908 20.621 42.3378 19.882 41.6182C19.1526 40.9181 18.1996 40.5291 17.198 40.5291C16.1672 40.5291 15.1754 40.9667 14.4655 41.7349L13.5611 42.6393C13.4055 42.7851 13.1819 42.8727 12.9485 42.8727C12.7151 42.8727 12.4817 42.7949 12.3553 42.6587L12.3456 42.649L12.3358 42.6393L10.1673 40.4805C9.84641 40.1596 9.84641 39.6247 10.1673 39.2941L11.0522 38.4189C11.8496 37.6799 12.2872 36.6977 12.2872 35.6475C12.2872 34.6361 11.8983 33.7123 11.1884 32.983C10.4688 32.2439 9.51578 31.8647 8.51417 31.8647H7.02635C6.54013 31.8647 6.1317 31.4465 6.1317 31.0089V29.5211V28.043C6.1317 27.6054 6.54013 27.1873 7.02635 27.1873H8.50445C9.50606 27.1873 10.459 26.808 11.1786 26.069C11.8885 25.3396 12.2775 24.3964 12.2775 23.3948C12.2775 22.3445 11.8399 21.3624 11.0425 20.6331L10.1479 19.7481C9.93393 19.5342 9.90476 19.2911 9.90476 19.1549C9.90476 19.0285 9.93393 18.7757 10.1479 18.5618L12.3067 16.4127C12.4623 16.2668 12.6859 16.1793 12.9193 16.1793C13.1527 16.1793 13.3861 16.2571 13.5125 16.3932L13.5222 16.403L13.5319 16.4127L14.446 17.3268C15.1656 18.1047 16.1381 18.5326 17.1786 18.5326C18.1899 18.5326 19.1332 18.1436 19.8625 17.4435C20.6016 16.7239 21.01 15.7806 21.01 14.7693V13.2912C21.01 12.8147 21.399 12.4062 21.8366 12.4062H24.8025C25.2401 12.4062 25.5804 12.8147 25.5804 13.2912V14.7693C25.5804 15.7709 26.0083 16.7239 26.7474 17.4435C27.4767 18.1436 28.4394 18.5326 29.4507 18.5326C30.501 18.5326 31.4928 18.095 32.2319 17.3073L33.1168 16.4224C33.2724 16.2765 33.4961 16.189 33.7294 16.189C33.9628 16.189 34.1962 16.2765 34.3421 16.4127L36.5106 18.5618C36.6662 18.7174 36.7635 18.9313 36.7635 19.1549C36.7635 19.3786 36.6759 19.5925 36.5203 19.7481L35.5965 20.6622C34.8186 21.3818 34.381 22.3543 34.381 23.4045C34.381 24.4158 34.77 25.3396 35.4798 26.069C36.1228 26.7293 36.952 27.1024 37.8358 27.1744L38.7509 25.6314Z"
        className="fill-current"
      />
      <path
        d="M23.3253 20.1858C20.8261 20.1858 18.4825 21.1582 16.7224 22.9183C14.9623 24.6784 13.9899 27.022 13.9899 29.5212C13.9899 32.0203 14.9623 34.3542 16.7224 36.124C18.4825 37.8841 20.8358 38.8565 23.3253 38.8565C25.8244 38.8565 28.168 37.8841 29.9281 36.124C31.6882 34.3639 32.6606 32.0203 32.6606 29.5212C32.6606 27.022 31.6882 24.6882 29.9281 22.9183C28.168 21.1582 25.8244 20.1858 23.3253 20.1858ZM23.3253 37.3006C19.0174 37.3006 15.5458 33.8096 15.5458 29.5212C15.5458 25.2327 19.0174 21.7417 23.3253 21.7417C27.6331 21.7417 31.1047 25.2327 31.1047 29.5212C31.1047 33.8096 27.6331 37.3006 23.3253 37.3006Z"
        className="fill-current"
      />
      <path
        d="M19.4142 29.1372L21.716 26.5484L18.3232 25.8494L19.4142 29.1372ZM27.4582 28.1366C27.4787 28.301 27.6286 28.4177 27.793 28.3973C27.9574 28.3768 28.0741 28.2269 28.0536 28.0625L27.4582 28.1366ZM20.2178 26.6444C20.8115 25.6334 21.851 24.901 23.1033 24.7452L23.0292 24.1498C21.5841 24.3295 20.3845 25.1757 19.7004 26.3405L20.2178 26.6444ZM23.1033 24.7452C25.2424 24.4791 27.1922 25.9975 27.4582 28.1366L28.0536 28.0625C27.7467 25.5946 25.4972 23.8428 23.0292 24.1498L23.1033 24.7452Z"
        className="fill-current"
      />
      <path
        d="M42.6895 22.1948L29.1255 45.0676C28.8458 45.5568 28.6979 46.1115 28.6963 46.6763C28.6947 47.2412 28.8396 47.7967 29.1166 48.2875C29.3935 48.7783 29.7929 49.1872 30.2749 49.4737C30.7569 49.7602 31.3047 49.9142 31.8639 49.9204H58.992C59.5512 49.9142 60.0991 49.7602 60.5811 49.4737C61.0631 49.1872 61.4624 48.7783 61.7393 48.2875C62.0163 47.7967 62.1612 47.2412 62.1596 46.6763C62.158 46.1115 62.0101 45.5568 61.7304 45.0676L48.1664 22.1948C47.8809 21.7194 47.4789 21.3263 46.9993 21.0535C46.5196 20.7808 45.9784 20.6375 45.428 20.6375C44.8775 20.6375 44.3363 20.7808 43.8567 21.0535C43.377 21.3263 42.975 21.7194 42.6895 22.1948V22.1948Z"
        className="stroke-current"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        r="1.47062"
        transform="matrix(-1 0 0 1 45.4288 43.7421)"
        fill="#06362F"
        className="fill-current"
      />
      <path
        d="M44.0141 33.5357C44.0141 36.353 43.929 40.4844 45.4295 40.4844C46.8448 40.4844 46.8448 36.353 46.8448 33.5357C46.8448 30.7185 46.5607 30.0168 45.4295 30.0168C44.2982 30.0168 44.0141 30.7185 44.0141 33.5357Z"
        fill="#06362F"
        className="fill-current"
      />
    </svg>
  );
};

const MagnifyingIcon = () => {
  return (
    <svg
      className="mx-auto"
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M58.6807 52.9785L44.6807 38.9785C44.0977 38.3955 43.3887 38.1035 42.6807 38.1035C42.4277 38.1035 42.1777 38.1545 41.9307 38.2285L39.9517 36.2495C42.2847 33.0945 43.6807 29.2055 43.6807 24.9785C43.6807 14.4835 35.1757 5.97852 24.6807 5.97852C14.1857 5.97852 5.68066 14.4835 5.68066 24.9785C5.68066 35.4735 14.1857 43.9785 24.6807 43.9785C28.9067 43.9785 32.7967 42.5825 35.9517 40.2495L37.9307 42.2285C37.6487 43.1675 37.8897 44.1875 38.6807 44.9785L52.6807 58.9785C53.2637 59.5615 53.9727 59.8535 54.6807 59.8535C55.3887 59.8535 56.0977 59.5615 56.6807 58.9785L58.6807 56.9785C59.8467 55.8125 59.8467 54.1445 58.6807 52.9785ZM24.6807 42.9785C14.7557 42.9785 6.68066 34.9035 6.68066 24.9785C6.68066 15.0535 14.7557 6.97852 24.6807 6.97852C34.6057 6.97852 42.6807 15.0535 42.6807 24.9785C42.6807 34.9035 34.6057 42.9785 24.6807 42.9785ZM38.4137 41.2975L36.7607 39.6445C37.7027 38.8675 38.5697 38.0005 39.3467 37.0585L40.9997 38.7115C40.8917 38.7955 40.7827 38.8765 40.6807 38.9785L38.6807 40.9785C38.5787 41.0805 38.4977 41.1895 38.4137 41.2975ZM57.9737 56.2715L55.9737 58.2715C55.5937 58.6525 55.1457 58.8535 54.6807 58.8535C54.2157 58.8535 53.7677 58.6525 53.3877 58.2715L39.3877 44.2715C38.6147 43.4985 38.6147 42.4585 39.3877 41.6855L41.3877 39.6855C41.7677 39.3045 42.2157 39.1035 42.6807 39.1035C43.1457 39.1035 43.5937 39.3045 43.9737 39.6855L57.9737 53.6855C58.7467 54.4585 58.7467 55.4985 57.9737 56.2715Z"
        className="fill-current"
      />
      <path
        d="M43.5898 42.2188L49.7613 48.3902"
        className="stroke-current"
        strokeLinecap="round"
      />
      <path
        d="M24.6807 8.97852C15.8587 8.97852 8.68066 16.1565 8.68066 24.9785C8.68066 33.8005 15.8587 40.9785 24.6807 40.9785C33.5027 40.9785 40.6807 33.8005 40.6807 24.9785C40.6807 16.1565 33.5027 8.97852 24.6807 8.97852ZM24.6807 39.9785C16.3967 39.9785 9.68066 33.2625 9.68066 24.9785C9.68066 16.6945 16.3967 9.97852 24.6807 9.97852C32.9647 9.97852 39.6807 16.6945 39.6807 24.9785C39.6807 33.2625 32.9647 39.9785 24.6807 39.9785Z"
        className="fill-current"
      />
      <path
        d="M23.2372 35.9115C23.1969 36.2177 23.4125 36.5 23.7203 36.5256C25.9451 36.7102 28.1805 36.2514 30.1576 35.1978C32.2996 34.0563 34.0311 32.2739 35.1102 30.0998C36.1892 27.9258 36.5617 25.4688 36.1755 23.0726C35.8191 20.8609 34.8328 18.803 33.3403 17.1427C33.1338 16.913 32.7786 16.912 32.5591 17.1293C32.3395 17.3466 32.339 17.6997 32.5443 17.9305C33.8733 19.4242 34.7519 21.2691 35.0712 23.2506C35.4203 25.4165 35.0836 27.6374 34.1082 29.6026C33.1329 31.5677 31.5677 33.1789 29.6316 34.2106C27.8603 35.1546 25.8597 35.5704 23.8663 35.4152C23.5584 35.3912 23.2775 35.6052 23.2372 35.9115Z"
        className="fill-current"
      />
    </svg>
  );
};

const StockIcon = () => {
  return (
    <svg
      className="mx-auto"
      width="61"
      height="62"
      viewBox="0 0 61 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.4349 22.5565L41.2536 39.9624L36.4292 34.7686L8.16742 60.0847"
        className="stroke-current"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.8405 22.5466H59.436V28.1292"
        className="stroke-current"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.44861 25.6388L4.44805 34.1756"
        className="stroke-current"
        strokeWidth="2"
      />
      <path
        d="M4.43579 3.23413L4.43968 12.3008"
        className="stroke-current"
        strokeWidth="2"
      />
      <rect
        x="1.71875"
        y="12.6469"
        width="5.44582"
        height="12.7644"
        className="stroke-current"
        strokeWidth="2"
      />
      <path
        d="M15.7426 39.0468L15.7422 44.6252"
        className="stroke-current"
        strokeWidth="2"
      />
      <path
        d="M15.7426 20.3317L15.7423 27.9107"
        className="stroke-current"
        strokeWidth="2"
      />
      <rect
        x="13.0255"
        y="28.9089"
        width="5.4365"
        height="9.33568"
        className="stroke-current"
        strokeWidth="2"
      />
      <path
        d="M27.0303 30.2358L27.03 35.8143"
        className="stroke-current"
        strokeWidth="2"
      />
      <path
        d="M27.0303 7.76941L27.0301 17.2209"
        className="stroke-current"
        strokeWidth="2"
      />
      <rect
        x="24.3133"
        y="16.9912"
        width="5.4365"
        height="12.4424"
        className="stroke-current"
        strokeWidth="2"
      />
      <path
        d="M38.3337 22.5507L38.3333 28.1291"
        className="stroke-current"
        strokeWidth="2"
      />
      <path
        d="M38.3337 0.0842285L38.3335 9.53571"
        className="stroke-current"
        strokeWidth="2"
      />
      <rect
        x="35.6166"
        y="9.30603"
        width="5.4365"
        height="12.4424"
        className="stroke-current"
        strokeWidth="2"
      />
    </svg>
  );
};
